import React, { useState, useRef, useEffect, useMemo } from "react"
import { useSpring } from "react-spring"

import { debounce } from "lodash"

import { randomFromString } from "./utils/randomness"

import accentSound from "./assets/audio/v3/hwexe_animals_4.mp3"
import backgroundSound from "./assets/audio/v3/hwexe_background_3.mp3"

import { animated } from "react-spring"

import { AMBIENT_VOLUME, ACCENT_VOLUME } from "./config"

import Pizzicato from "pizzicato"

import note0 from "./assets/audio/v3/trigger_soundi 3-2-Audio 1.mp3"
import note1 from "./assets/audio/v3/trigger_soundi 4-2-Audio 1.mp3"
import note2 from "./assets/audio/v3/trigger_soundi 5-2-Audio 1.mp3"
import note3 from "./assets/audio/v3/trigger_soundi 6-2-Audio 1.mp3"
import note4 from "./assets/audio/v3/trigger_soundi 7-2-Audio 1.mp3"
import note5 from "./assets/audio/v3/trigger_soundi 8-2-Audio 1.mp3"
import note6 from "./assets/audio/v3/trigger_soundi 9-2-Audio 1.mp3"
import note7 from "./assets/audio/v3/tigger_soundi_visoki_1.mp3"
import note8 from "./assets/audio/v3/tigger_soundi_visoki_2.mp3"
import note9 from "./assets/audio/v3/tigger_soundi_visoki_3.mp3"
import note10 from "./assets/audio/v3/tigger_soundi_visoki_4.mp3"

import { SPEED } from "./config"

const springConfig = {
	mass: 1,
	tension: 170,
	friction: 64,
	clamp: false,
	precision: 0.01,
	velocity: 0,
	duration: undefined,
}

function AccentSound({ volume }) {
	const accentRef = useRef()

	// useEffect(() => {
	// 	accentRef.current.currentTime = 48
	// }, [])

	useEffect(() => {
		accentRef.current.volume = volume
	}, [volume])

	return (
		<audio loop autoPlay ref={accentRef}>
			<source src={accentSound} />
		</audio>
	)
}

function BackgroundSound({ volume }) {
	const bgRef = useRef()

	useEffect(() => {
		bgRef.current.volume = volume
	}, [volume])

	return (
		<audio loop autoPlay ref={bgRef}>
			<source src={backgroundSound} />
		</audio>
	)
}

const AnimatedAccentSound = animated(AccentSound)

let downTimeout

async function loadSounds(onLoad) {
	await fetch(backgroundSound)
	await fetch(accentSound)
	onLoad && onLoad()
}

const percSounds = []

const notes = [
	note0,
	note1,
	note2,
	note3,
	note4,
	note5,
	note6,
	note7,
	note8,
	note9,
	note10,
]

notes.forEach((note) => {
	const sound = new Pizzicato.Sound(note, () => {
		const pan = new Pizzicato.Effects.StereoPanner({
			pan: 0.25 + Math.random() * 0.5,
		})
		sound.addEffect(pan)
		// percSounds.push(sound)
		const play = function (volume) {
			sound.stop()
			sound.volume = volume
			sound.play()
		}
		percSounds.push(debounce(play, 90))
	})
})

export function Sounds({ seed, onLoad, isActive = true }) {
	const [accentVolume, setAccentVolume] = useState(0)

	useEffect(() => {
		loadSounds(onLoad)
	}, [onLoad])

	const rand = useMemo(() => {
		return randomFromString(seed)
	}, [seed])

	useEffect(() => {
		setAccentVolume(ACCENT_VOLUME)
		if (downTimeout) clearTimeout(downTimeout)
		downTimeout = setTimeout(() => setAccentVolume(0), 500)
		const randomSample = percSounds[Math.floor(rand() * percSounds.length)]

		if (randomSample && isActive) {
			setTimeout(() => {
				randomSample(0.5 + rand() * 0.25)
			}, (rand() * SPEED) / 4)
		}
	}, [isActive, rand, seed])

	const animatedVolume = useSpring({
		config: springConfig,
		value: accentVolume,
	})

	return (
		<div className="Sounds">
			{isActive && (
				<>
					<BackgroundSound volume={AMBIENT_VOLUME} />
					<AnimatedAccentSound volume={animatedVolume.value} />
				</>
			)}
		</div>
	)
}
